/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { generateImageUrl } from '../../../util/helpers';
import { Variant } from '../../products/storage';
import { DimensionTypes } from '../../products/utils/useVariations';
import { CartItem } from '../storage/cart.types';
import { getVariantDimensionByType } from './get-variant-dimension';

export const getUpdatedVariant = (variant: Variant, product: CartItem): CartItem => {
  return {
    ...product,
    productId: variant.productId,
    size: getVariantDimensionByType(variant, DimensionTypes.SIZE)?.id,
    sizeDescription: getVariantDimensionByType(variant, DimensionTypes.SIZE)?.value,
    colour: getVariantDimensionByType(variant, DimensionTypes.COLOUR)?.id,
    colourDescription: getVariantDimensionByType(variant, DimensionTypes.COLOUR)?.value,
    imageUrl: generateImageUrl(product.itemNumber),
  };
};
